import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface MyBudget {
    totalBudget?: string;
    totalSpent?: string;
    budgetHeading?: string;
}

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCurrentCartState(state);
    return {
        gaiaBudget: state.context.session.properties?.gaiaBudget,
        utilizedGaiaBudget: cartState.value?.properties?.utilizedGaiaBudget,
        utilizedSalusBudget: cartState.value?.properties?.utilizedSalusBudget,
        salusBudget: state.context.session.properties?.salusBudget,
        userType: state.context.session.properties?.userType,
        isEnabledCarstock: state.context.settings.properties?.isCarStockEnabled,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface MyBudgetCheckoutReviewAndSubmitStyles {
    wrapper?: InjectableCss;
    mainWrapper?: InjectableCss;
    progressWrapper?: InjectableCss;
    budgetName?: TypographyPresentationProps;
    totalBudgetWrapper?: InjectableCss;
    budgetSpentWrapper?: InjectableCss;
    totalBudgetAmount?: TypographyPresentationProps;
    progressContainer?: InjectableCss;
    spentAmount?: TypographyPresentationProps;
}

const styles: MyBudgetCheckoutReviewAndSubmitStyles = {
    wrapper: {
        css: css`
            background: #f3efeb;
            padding: 16px 37px;
            border-radius: 8px;
            margin-bottom: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 15px;
                        > div:first-child {
                            border-bottom: 1px solid #dcdcdc;
                        }
                    `,
                    css`
                        padding: 0 15px;
                        > div:first-child {
                            border-bottom: 1px solid #dcdcdc;
                        }
                    `,
                    css`
                        padding: 0 15px;
                        > div:first-child {
                            border-bottom: 1px solid #dcdcdc;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    budgetName: {
        fontFamily: "LibreBaskervilleBold",
        size: 18,
        color: "text.main",
        css: css``,
    },
    mainWrapper: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    progressWrapper: {
        css: css`
            flex: 1;
            display: flex;
            flex-direction: column;
            .budget {
                width: 100%;
                margin: 15px 0px 10px;
                border-radius: 10px;
                overflow: hidden;
                border: none;
            }
            /* background: */
            progress::-webkit-progress-bar {
                background-color: #ffffff;
                width: 100%;
            }
            progress {
                background-color: #ffffff;
            }
            /* value: */
            progress::-webkit-progress-value {
                background-color: #64a70b !important;
            }
            progress::-moz-progress-bar {
                background-color: #64a70b !important;
            }
            progress {
                color: #64a70b;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    totalBudgetWrapper: {
        css: css`
            padding-left: 18px;
            display: flex;
            flex-direction: column;
            text-align: center;
            align-items: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-top: 15px;
                    `,
                    css`
                        order: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-top: 15px;
                    `,
                    css`
                        order: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-top: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    totalBudgetAmount: {
        size: 30,
        fontFamily: "LatoBold",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 25px;
                    `,
                    css`
                        font-size: 25px;
                    `,
                    css`
                        font-size: 25px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    spentAmount: {
        fontFamily: "LatoBold",
        css: css`
            margin-left: 5px;
        `,
    },
    budgetSpentWrapper: {
        css: css``,
    },
    progressContainer: {
        css: css`
            :first-child {
                margin-bottom: 30px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 30px 15px;
                        :first-child {
                            margin-bottom: 0;
                        }
                    `,
                    css`
                        padding: 30px 15px;
                        :first-child {
                            margin-bottom: 0;
                        }
                    `,
                    css`
                        padding: 30px 15px;
                        :first-child {
                            margin-bottom: 0;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const ProgressIndicator = ({ totalBudget, totalSpent, budgetHeading }: MyBudget) => {
    const convertToNumber = (value: string) => {
        return value.replace(",", "");
    };
    return (
        <StyledWrapper {...styles.progressContainer}>
            <Typography {...styles.budgetName}>{budgetHeading}</Typography>
            <StyledWrapper {...styles.mainWrapper}>
                <StyledWrapper {...styles.progressWrapper}>
                    <progress
                        className="budget"
                        value={convertToNumber(totalSpent as string)}
                        max={convertToNumber(totalBudget as string)}
                    />
                    <Typography {...styles.budgetSpentWrapper}>
                        {translate("Budget spent")}
                        <Typography {...styles.spentAmount}>${totalSpent}</Typography>
                    </Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.totalBudgetWrapper}>
                    <Typography {...styles.totalBudgetAmount}>${totalBudget}</Typography>
                    <Typography>{translate("Total Budget")}</Typography>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const MyBudgetCheckoutReviewAndSubmit: React.FC<Props> = ({
    gaiaBudget,
    utilizedGaiaBudget,
    utilizedSalusBudget,
    salusBudget,
    userType,
    isEnabledCarstock,
}) => {
    const isBroker = userType === "BROKER";
    if (isEnabledCarstock === "false") {
        return null;
    }
    return isBroker && (gaiaBudget || salusBudget) ? (
        <StyledWrapper {...styles.wrapper}>
            {gaiaBudget && (
                <ProgressIndicator
                    budgetHeading="My Gaia Budget"
                    totalBudget={gaiaBudget}
                    totalSpent={utilizedGaiaBudget || "0"}
                />
            )}
            {salusBudget && (
                <ProgressIndicator
                    budgetHeading="My Salus Budget"
                    totalBudget={salusBudget}
                    totalSpent={utilizedSalusBudget || "0"}
                />
            )}
        </StyledWrapper>
    ) : null;
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyBudgetCheckoutReviewAndSubmit),
    definition: {
        group: "Common",
        displayName: "My Budget Indicator",
    },
};


export default widgetModule;
